import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import BcMask from '@/components/Mask.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
let SyncList = class SyncList extends Vue {
    constructor(props) {
        super(props);
        // 数据属性
        this.dataList = [];
        this.summaryContent = {};
        this.pagination = {};
        this.maskValue = {};
        this.dialog = {
            isShow: false,
            title: ''
        };
        this.dialogDom = [];
        this.snackbar = new CBcSnackbar();
        this.loading = false;
        // 记录人下拉项（对象数组，item-text/text + item-value/value）
        this.recorderItems = [];
        // 搜索选项
        this.searchOptions = {
            deviceName: '',
            deviceType: '',
            hospitalName: '',
            recorder: ''
        };
        // 表格选项
        this.options = {
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: [],
            multiSort: false,
            mustSort: false
        };
        // 表格列定义
        this.headers = [
            { text: '设备信息', value: 'deviceInfo', sortable: false, width: '180px' },
            { text: '设备类型', value: 'deviceType', sortable: false, width: '120px' },
            { text: '医院名称', value: 'hospitalInfo', sortable: false, width: '150px' },
            { text: '同步时间', value: 'date', sortable: true, width: '120px' },
            { text: '配药统计', value: 'total', sortable: false, width: '120px' },
            { text: '成功率', value: 'successRate', sortable: false, width: '100px' },
            { text: '记录人', value: 'recorder', sortable: false, width: '100px' },
            { text: '操作', value: 'actions', sortable: false, width: '80px' }
        ];
        // 搜索防抖定时器
        this.searchTimer = null;
        const that = this;
        that.summaryContent = {
            summaryDeviceNum: '0台',
            lastSyncDateTime: '无',
            unSyncSummaryDay: '无'
        };
        that.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
            total: 0,
            totalPages: 0
        };
        that.maskValue = {
            isShow: false
        };
        that.dialog = {
            isShow: false,
            title: '设备同步详情'
        };
    }
    // 计算属性
    get dynamicHeight() {
        return 'calc(100vh - 120px)';
    }
    // 格式化日期方法
    formatDate(date) {
        if (!date)
            return '无';
        try {
            const d = new Date(date);
            if (isNaN(d.getTime()))
                return '无';
            return d.getFullYear() + '-'
                + String(d.getMonth() + 1).padStart(2, '0') + '-'
                + String(d.getDate()).padStart(2, '0') + ' '
                + String(d.getHours()).padStart(2, '0') + ':'
                + String(d.getMinutes()).padStart(2, '0');
        }
        catch (error) {
            return '无';
        }
    }
    async created() {
        const that = this;
        // 获取设备类型列表
        await this.fetchDeviceModeCatalog();
        // 获取设备列表（用于设备名称/ID 下拉搜索）
        await this.fetchDevices().catch((e) => console.warn('加载设备列表失败:', e));
        // 获取医院列表（用于医院名称下拉搜索）
        await this.fetchHospitals().catch((e) => console.warn('加载医院列表失败:', e));
        // 获取记录人列表（用户列表取 usersInfo.name）
        try {
            const res = await that.$http.get('/api/users/');
            const users = ((res.data && res.data.result) || []).map((u) => u && u.usersInfo).filter(Boolean);
            // 去重并转成 { text, value } 对象数组
            const seen = new Set();
            that.recorderItems = users
                .map((u) => u.name)
                .filter((n) => n && !seen.has(n) && seen.add(n))
                .map((name) => ({ text: name, value: name }));
        }
        catch (e) {
            console.warn('加载记录人列表失败:', e);
        }
        that.getSyncList();
    }
    async getSyncList() {
        const that = this;
        that.loading = true;
        // 构建搜索参数，过滤空值
        const searchParams = {};
        if (that.searchOptions.deviceName && that.searchOptions.deviceName.trim()) {
            // 后端支持deviceId参数进行设备查询
            searchParams.deviceId = that.searchOptions.deviceName.trim();
        }
        if (that.searchOptions.deviceType) {
            searchParams.deviceType = that.searchOptions.deviceType;
        }
        if (that.searchOptions.hospitalName && that.searchOptions.hospitalName.trim()) {
            // 暂时保留hospitalName参数
            searchParams.hospitalName = that.searchOptions.hospitalName.trim();
        }
        if (that.searchOptions.recorder && that.searchOptions.recorder.trim()) {
            searchParams.recorder = that.searchOptions.recorder.trim();
        }
        const params = {
            page: that.options.page,
            limit: that.options.itemsPerPage,
            ...searchParams
        };
        console.log('发送分页请求参数:', params);
        try {
            const res = await that.$http.get('/api/device/sync', { params });
            console.log('接口返回数据:', res.data);
            if (res.data && res.data.result && Array.isArray(res.data.result)) {
                that.dataList = res.data.result;
                // 使用接口返回的summary信息
                const summary = res.data.summary || {};
                const pagination = res.data.pagination || {};
                that.summaryContent = {
                    summaryDeviceNum: (summary.totalDevices || that.dataList.length) + '台',
                    lastSyncDateTime: summary.lastSyncTime || null,
                    unSyncSummaryDay: summary.unsyncDays ? summary.unsyncDays + '天' : '无'
                };
                // 使用接口返回的分页信息
                that.pagination.sumDetail = pagination.total || res.data.total || that.dataList.length;
                that.pagination.total = pagination.total || res.data.total || that.dataList.length;
                that.pagination.pageCount = pagination.totalPages || Math.ceil(that.pagination.sumDetail / that.options.itemsPerPage);
                that.pagination.totalPages = pagination.totalPages || Math.ceil(that.pagination.sumDetail / that.options.itemsPerPage);
                console.log('分页信息更新:', {
                    total: pagination.total || res.data.total,
                    page: pagination.page,
                    limit: pagination.limit,
                    totalPages: pagination.totalPages,
                    currentOptions: that.options,
                    dataListLength: that.dataList.length
                });
            }
            else {
                console.warn('接口返回数据格式异常:', res.data);
                that.dataList = [];
                that.summaryContent = {
                    summaryDeviceNum: '0台',
                    lastSyncDateTime: null,
                    unSyncSummaryDay: '无'
                };
                that.pagination.sumDetail = 0;
                that.snackbar.error('获取数据失败: 数据格式异常');
            }
        }
        catch (error) {
            console.error('获取同步列表失败:', error);
            console.error('错误详情:', error.response?.data || error.message);
            that.dataList = [];
            that.summaryContent = {
                summaryDeviceNum: '0台',
                lastSyncDateTime: null,
                unSyncSummaryDay: '无'
            };
            that.pagination.sumDetail = 0;
            // 更详细的错误信息
            let errorMessage = '网络错误';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            }
            else if (error.message) {
                errorMessage = error.message;
            }
            that.snackbar.error('获取数据失败: ' + errorMessage);
        }
        that.loading = false;
    }
    // 搜索方法
    handleSearch() {
        // 清除之前的定时器
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        // 设置新的定时器，500ms后执行搜索
        this.searchTimer = setTimeout(() => {
            this.options.page = 1;
            this.getSyncList();
        }, 500);
    }
    // 立即搜索（用于下拉选择等）
    handleImmediateSearch() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        this.options.page = 1;
        this.getSyncList();
    }
    // 重置搜索
    resetSearch() {
        this.searchOptions = {
            deviceName: '',
            deviceType: '',
            hospitalName: '',
            recorder: ''
        };
        this.handleSearch();
    }
    // 刷新数据
    refreshData() {
        this.getSyncList();
    }
    // 表格选项变化
    onOptionsUpdate(newOptions) {
        console.log('分页选项更新:', newOptions);
        console.log('当前选项:', this.options);
        // 检查是否是页码或每页条数的变化
        const pageChanged = this.options.page !== newOptions.page;
        const itemsPerPageChanged = this.options.itemsPerPage !== newOptions.itemsPerPage;
        const sortChanged = JSON.stringify(this.options.sortBy) !== JSON.stringify(newOptions.sortBy)
            || JSON.stringify(this.options.sortDesc) !== JSON.stringify(newOptions.sortDesc);
        // 更新选项
        this.options = { ...newOptions };
        // 如果页码、每页条数或排序发生变化，重新获取数据
        if (pageChanged || itemsPerPageChanged || sortChanged) {
            console.log('分页参数变化，重新获取数据:', {
                pageChanged,
                itemsPerPageChanged,
                sortChanged,
                newPage: newOptions.page,
                newItemsPerPage: newOptions.itemsPerPage
            });
            this.getSyncList();
        }
    }
    // 计算成功率
    getSuccessRate(item) {
        const total = item.total || 0;
        const success = item.success || 0;
        return total > 0 ? (success / total) * 100 : 0;
    }
    // 获取成功率颜色
    getSuccessRateColor(rate) {
        if (rate >= 90)
            return 'success';
        if (rate >= 70)
            return 'warning';
        return 'error';
    }
    dateDifferentDay(startDate, endDate) {
        // eslint-disable-next-line no-unused-expressions
        startDate
            && endDate
            && startDate.replace('-', '/')
            && endDate.replace('-', '/');
        let aDate = startDate.split('-');
        const oDate1 = new Date(aDate[0] + '-' + aDate[1] + '-' + aDate[2]); // 转换为12-18-2002格式
        aDate = endDate.split('-');
        const oDate2 = new Date(aDate[0] + '-' + aDate[1] + '-' + aDate[2]);
        const iDays = Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24; // 把相差的毫秒数转换为天数
        return iDays;
    }
    showItemDetail(value) {
        const that = this;
        that.dialog.isShow = !that.dialog.isShow;
        // 修改v-for渲染的DOM树
        that.dialogDom = [
            [
                { label: '设备ID', values: (value.deviceInfo && value.deviceInfo.deviceId) || '无' },
                { label: '设备名称', values: (value.deviceInfo && value.deviceInfo.name) || '无' },
                { label: '设备类型', values: (value.deviceInfo && value.deviceInfo.type) || '无' },
            ],
            [
                { label: '医院名称', values: (value.hospitalInfo && value.hospitalInfo.name) || '无' },
                { label: '同步时间', values: value.date || '无' },
                { label: '记录人', values: value.recorder || '无' }
            ],
            [
                { label: '配药总数', values: value.total || '0' },
                { label: '成功数', values: value.success || '0' },
                { label: '失败数', values: value.fails || '0' }
            ],
        ];
        console.log(value);
    }
    // 关闭详情对话框
    closeDialog() {
        this.dialog.isShow = false;
    }
    // 组件销毁时清理定时器
    beforeDestroy() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
            this.searchTimer = null;
        }
    }
};
SyncList = __decorate([
    Component({
        name: 'sync',
        components: {
            BcMask,
            BcSnackbar
        },
        computed: {
            ...mapGetters(['deviceTypeList', 'deviceList', 'hospitalsList']),
            // 设备名称/ID/编码 下拉项：改成对象数组，text 合并 name + deviceId + deviceNo，支持任何一个字段检索
            deviceNameItems() {
                const list = this.deviceList || [];
                const seen = new Set();
                const items = [];
                list.forEach((d) => {
                    // text 包含多个可搜索字段，v-combobox 默认 filter 会同时匹配 text
                    const name = d.name || '';
                    const id = d.deviceId || '';
                    const no = d.deviceNo || '';
                    const text = [name, id, no].filter(Boolean).join(' / ');
                    if (!text || seen.has(text))
                        return;
                    seen.add(text);
                    items.push({ text, value: name || id || no });
                });
                return items;
            },
            // 医院名称下拉项
            hospitalNameItems() {
                const list = this.hospitalsList || [];
                return [...new Set(list.map((h) => h && h.name).filter(Boolean))].map(name => ({ text: name, value: name }));
            }
        },
        methods: {
            ...mapActions(['fetchDeviceModeCatalog', 'fetchDevices', 'fetchHospitals'])
        }
    })
], SyncList);
export default SyncList;
